import { canonicalJsonStringify, compareDecimalCursors, compareInstants, deviceCursorSchema, } from '@der-maschinfuehrer/contracts';
import { FullResyncRequiredError } from '../errors.js';
export async function putValidatedDeviceCursor(table, cursorInput, profile) {
    const cursor = deviceCursorSchema.parse(cursorInput);
    const account = profile.account_identity;
    if (account === null ||
        cursor.account_identity.issuer !== account.issuer ||
        cursor.account_identity.subject !== account.subject) {
        throw new FullResyncRequiredError('device cursor belongs to another or anonymous profile');
    }
    if (cursor.dataset_epoch !== profile.dataset_epoch) {
        throw new FullResyncRequiredError('device cursor belongs to another dataset epoch');
    }
    const existingInput = await table.get(cursor.device_id);
    if (existingInput !== undefined) {
        const existing = deviceCursorSchema.parse(existingInput);
        if (existing.account_identity.issuer !== cursor.account_identity.issuer ||
            existing.account_identity.subject !== cursor.account_identity.subject) {
            throw new FullResyncRequiredError('stored device cursor belongs to another account');
        }
        const registrationOrder = compareInstants(cursor.registered_at, existing.registered_at);
        if (registrationOrder < 0) {
            throw new FullResyncRequiredError('device registration cannot move backwards');
        }
        if (existing.dataset_epoch === cursor.dataset_epoch &&
            compareDecimalCursors(cursor.last_applied_cursor, existing.last_applied_cursor) < 0) {
            throw new FullResyncRequiredError('device watermark cannot move backwards');
        }
        const sameRegistration = registrationOrder === 0;
        if (existing.dataset_epoch === cursor.dataset_epoch &&
            sameRegistration &&
            ((existing.registration_status !== 'active' && cursor.registration_status === 'active') ||
                (existing.requires_full_resync && !cursor.requires_full_resync))) {
            throw new FullResyncRequiredError('an expired, revoked, or stale registration requires explicit re-registration');
        }
        if (canonicalJsonStringify(existing) ===
            canonicalJsonStringify(cursor)) {
            return false;
        }
    }
    await table.put(cursor);
    return true;
}
//# sourceMappingURL=device-cursor.js.map